<script>
import { Doughnut } from 'vue-chartjs'

export default {
    extends: Doughnut,
    props: {
        chartLabels: {
            type: Array,
            default: () => []
        },
        chartData: {
            type: Array,
            default: () => []
        }
    },
    watch: {
        chartData() {
            this.render()
        }
    },
    mounted() {
        this.render()
    },
    methods: {
        render() {
            const colors = [
                '#34C38F', '#50A5F1', '#F1B44C', '#F46A6A', '#556EE6',
                '#74788D', '#343A40', '#51D28C', '#3B82F6', '#A855F7',
                '#EF4444', '#F59E0B', '#10B981', '#6366F1', '#EC4899'
            ];

            this.renderChart({
                labels: this.chartLabels,
                datasets: [{
                    data: this.chartData,
                    backgroundColor: colors.slice(0, this.chartData.length),
                    borderWidth: 1,
                    borderColor: '#fff'
                }]
            }, {
                responsive: true,
                maintainAspectRatio: false,
                cutoutPercentage: 60,
                legend: {
                    display: false
                },
                tooltips: {
                    callbacks: {
                        label: (tooltipItem, data) => {
                            const dataset = data.datasets[tooltipItem.datasetIndex];
                            const total = dataset.data.reduce((a, b) => a + b, 0);
                            const value = dataset.data[tooltipItem.index];
                            const pct = Math.round((value / total) * 100);
                            return ` ${data.labels[tooltipItem.index]}: ${value} (${pct}%)`;
                        }
                    }
                }
            })
        }
    }
}
</script>
